/* src/app/shared/components/mce-data-table/mce-data-table.component.scss */
tr.displayHeader {
  font-weight: bold;
}
tr.displayRow:hover {
  background: var(--mat-sys-surface-container);
}
/*# sourceMappingURL=mce-data-table.component-WRR6ZOQU.css.map */
